import React, { useState, useEffect } from "react";
import { StyledInput } from "@/components/styled";

type Props = {
  isNote: boolean;
  currentNote: string | null;
  handleDeleteNote: () => void;
  handleSaveNote: (values: { note: string }) => void;
};

const EditableNote = ({ currentNote, handleSaveNote }: Props) => {
  const [note, setNote] = useState(currentNote || "");
  const [lastSaved, setLastSaved] = useState(currentNote || "");

  useEffect(() => {
    setNote(currentNote || "");
    setLastSaved(currentNote || "");
  }, [currentNote]);

  const handleBlur = () => {
    if (note !== lastSaved) {
      handleSaveNote({ note });
      setLastSaved(note);
    }
  };

  return (
    <StyledInput
      value={note}
      onChange={(e) => setNote(e.target.value)}
      onBlur={handleBlur}
      placeholder="Add note"
      sx={{
        fontSize: "14px",
        fontWeight: 400,
        background: "#FAFBFC",
        border: "1px solid #E0E3E7",
        borderRadius: "8px",
        width: "300px",
        color: note ? "#0A2540" : "#8C98A4",
        boxSizing: "border-box",
        padding: "6px 16px",
        marginX: "16px",
        "::placeholder": {
          color: "#8C98A4",
          fontSize: "14px",
          fontWeight: 400,
          opacity: 1,
        },
        "&:focus": {
          border: "1px solid #0078D5",
          background: "#fff",
        },
        "&.Mui-focused": {
          border: "1px solid #0078D5",
          background: "#fff",
        },
        resize: "none",
        overflow: "hidden",
        "& .MuiInputBase-input": {
          padding: 0,
          border: "none",
          boxShadow: "none",
          outline: "none",
          background: "transparent",
        },
      }}
      multiline
      minRows={1}
      maxRows={6}
      fullWidth
    />
  );
};

export default EditableNote;
